import { useNavigate } from 'react-router-dom';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { IS_SANDBOX } from '@backrs_ui/grow-ui/src/utils/sandboxSession';

import { Button, SxProps, Theme } from '@mui/material';

const STRINGS = appStrings.modules.pageShell.header;

type CoachingGuideButtonsProps = Readonly<{
  idPrefix: string;
  includeKeyLevers?: boolean;
}>;

export const CoachingGuideButtons = ({
  idPrefix,
  includeKeyLevers = true,
}: CoachingGuideButtonsProps) => {
  const navigate = useNavigate();

  return (
    <>
      {includeKeyLevers && !IS_SANDBOX && (
        <Button
          id={`${idPrefix}-key-levers-button`}
          hierarchy="Secondary gray"
          size="md"
          sx={noWrapSx}
          onClick={() => navigate(APP_ROUTE.KEY_LEVERS)}
        >
          {STRINGS.keyLeversButton}
        </Button>
      )}
      <Button
        id={`${idPrefix}-success-system-button`}
        hierarchy="Secondary gray"
        size="md"
        sx={noWrapSx}
        onClick={() => navigate(APP_ROUTE.SUCCESS_SYSTEM)}
      >
        {STRINGS.successSystemButton}
      </Button>
    </>
  );
};

const noWrapSx: SxProps<Theme> = { whiteSpace: 'nowrap' };
